import { render, staticRenderFns } from "./EmailTypes.vue?vue&type=template&id=24910168&scoped=true&"
import script from "./EmailTypes.vue?vue&type=script&lang=js&"
export * from "./EmailTypes.vue?vue&type=script&lang=js&"
import style0 from "./EmailTypes.vue?vue&type=style&index=0&id=24910168&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24910168",
  null
  
)

export default component.exports